module.exports = __webpack_public_path__ + "img/vi.c60f0454.svg";